<template xmlns="http://www.w3.org/1999/html">
  <div class="bg">
    <div class="container">
      <el-row>
        <el-row :gutter="15">
          <el-col :span="16">
            <el-card shadow="never" class="box-card">
              <div>
                <el-row :gutter="15">
                  <el-col class="comtab" :span="24">
                    <div class="tab">
                      <div
                        @click="officeProduct"
                        :class="
                          officeTab ? 'left_product_choose' : 'left_product'
                        "
                        style="margin-right: 20px"
                      >
                        {{ "办公应用" }}
                      </div>
                      <div
                        @click="allProduct"
                        :class="
                          productTab ? 'left_product_choose' : 'left_product'
                        "
                        style="margin-right: 20px"
                      >
                        {{ isall ? "全部产品" : "我的产品" }}
                      </div>
                      <div
                        @click="setapplication"
                        :class="
                          application ? 'left_product_choose' : 'left_product'
                        "
                      >
                        我的订单
                      </div>
                    </div>
                    <div class="right" v-if="officeTab">
                      <el-input
                        size="small"
                        style="width: 100%"
                        @input="keywordChange($event)"
                        suffix-icon="el-icon-search"
                        placeholder="搜索"
                        v-model="officeQueryParams.officeName"
                      >
                      </el-input>
                    </div>
                  </el-col>
                  <el-col class="comcol" :span="24" v-if="productTab">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                      <el-tab-pane label="已购买" name="first"> </el-tab-pane>
                      <el-tab-pane label="咨询" name="zixun"></el-tab-pane>
                      <el-tab-pane label="询价" name="xunjia"></el-tab-pane>
                      <el-tab-pane label="试用" name="fourth"></el-tab-pane>
                    </el-tabs>
                    <el-col :span="24" v-if="isEmpty">
                      <el-empty
                        :image="
                          require('../../static/img/display-img/noData.png')
                        "
                        description="暂无产品"
                      ></el-empty>
                    </el-col>
                    <div
                      v-if="activeName == 'zixun' || activeName == 'xunjia'"
                      v-loading="loading"
                    >
                      <div

                      >
                        <div class="product-div">
                          <div
                            class="product-style"
                            v-for="(item, key, index) in productarr"
                        :key="key + index"
                            @click="getproductdetail(item)"
                          >
                            <div class="product-detail">
                              <div class="product-toxiang" v-if="false">
                                <img :src="item.logoUrl" style="width: 100%" />
                              </div>
                              <div class="product_content">
                                <div>
                                  <span>{{ item.productName }}</span>
                                  <span
                                    :class="
                                      item.communicationState == 0
                                        ? 'redspan'
                                        : 'greenspan'
                                    "
                                  >
                                    {{
                                      item.communicationState == 0
                                        ? "未沟通"
                                        : "已沟通"
                                    }}
                                  </span>
                                </div>
                                <div class="demandDesc">
                                  {{ item.demandDesc }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="activeName == 'fourth'" v-loading="loading">
                      <div

                      >
                        <div class="product-div">
                          <div
                            class="product-style"
                            v-for="(item, key, index) in trialobjList"
                        :key="key + index"
                          >
                            <div class="product-detail">
                              <div class="product-toxiang" v-if="false">
                                <img :src="item.logo_url" style="width: 100%" />
                              </div>
                              <div class="product_content">
                                <div>
                                  <span>{{ item.demand_name }}</span>
                                  <span class="bluespan">试用中</span>
                                </div>
                                <div class="trialList">
                                  <p class="desc">{{ item.demand_desc }}</p>
                                  <p>
                                    <span>应用地址：</span>
                                    <span
                                      @click="openapplication(item.app_url)"
                                      class="a-link"
                                      >{{ item.app_url }}</span
                                    >
                                  </p>
                                  <p>
                                    <span>登录账号：</span>
                                    <span> {{ item.app_username }}</span>
                                    <span
                                      class="copytext"
                                      @click="copybutton(item.app_username)"
                                      >复制</span
                                    >
                                  </p>
                                  <p>
                                    <span>登录密码：</span>
                                    <span> {{ item.app_password }}</span>
                                    <span
                                      class="copytext"
                                      @click="copybutton(item.app_password)"
                                      >复制</span
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="activeName == 'first'">
                      <div>
                        <div class="product-div">
                          <div
                            class="product-style"
                            v-for="(item, key, index) in productList"
                            :key="index + key"
                            @click="handleItemClick(item)"
                          >
                            <div class="product-detail">
                              <div class="product-toxiang" v-if="false">
                                <img :src="item.logo_url" style="width: 100%" />
                              </div>
                              <div class="product_content">
                                <div>
                                  <span>{{ item.dict_label }}</span>
                                  <span class="greenspan"> 已购买 </span>
                                </div>
                                <div class="demandDesc">
                                  {{ item.demand_desc }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="officeTab">
                    <el-empty
                      v-if="!officetList.length"
                      :image="
                        require('../../static/img/display-img/noData.png')
                      "
                      description="暂无产品"
                    ></el-empty>
                  </el-col>

                  <el-col
                    class="comcol"
                    :span="6"
                    v-for="(item, index) in officetList"
                    :key="index"
                    v-if="officeTab"
                  >
                    <el-button
                      class="combutton_office"
                      plain
                      @click="officeItemClick(item)"
                    >
                      <div class="com_office">
                        <div class="com_office_img">
                          <img :src="item.img" alt="" />
                        </div>
                        <div class="com_office_name">
                          <p class="text">{{ item.name }}</p>
                        </div>
                      </div>
                    </el-button>
                  </el-col>
                  <!-- 我的订单 -->
                  <el-col class="comcol" :span="24" v-if="application">
                    <el-tabs v-model="payStatus" @tab-click="ordergetList">
                      <el-tab-pane label="已购买" name="1"> </el-tab-pane>
                      <el-tab-pane label="未支付" name="23"></el-tab-pane>
                    </el-tabs>
                    <el-form :inline="true" size="mini">
                      <el-form-item label="应用名称">
                        <el-input
                          style="width: 120px"
                          v-model="orderparams.productName"
                          placeholder="请输入应用名称"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="订单时间" v-if="payStatus == 1">
                        <el-date-picker
                          style="width: 360px"
                          v-model="orderTime"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          @change="timeChange"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-button type="primary" size="mini" @click="ordersearch"
                        >查询</el-button
                      >
                      <el-button size="mini" plain @click="clearSearch"
                        >重置</el-button
                      >
                    </el-form>
                    <el-empty
                      v-if="tableData.length <= 0"
                      :image="
                        require('../../static/img/display-img/noData.png')
                      "
                      description="暂无订单"
                    ></el-empty>
                    <el-table
                      v-if="tableData.length > 0"
                      :data="tableData"
                      style="width: 100%"
                    >
                      <el-table-column type="index" width="25" v-if="false">
                      </el-table-column>
                      <el-table-column
                        v-if="payStatus == 1"
                        prop="create_time"
                        label="订单日期"
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        v-if="payStatus == 1"
                        prop="order_code"
                        label="订单编号"
                        width="200"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="product_name"
                        label="产品服务"
                        min-width="60"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="available_duration"
                        label="试用年限/年"
                        :width="payStatus == 23 ? 110 : 90"
                      >
                        <template slot-scope="scope">
                          {{
                            scope.row.available_duration == 0
                              ? "永久有效"
                              : scope.row.available_duration == 1
                              ? "1"
                              : scope.row.available_duration == 2
                              ? "2"
                              : scope.row.available_duration == 3
                              ? "3"
                              : scope.row.available_duration
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="order_amount"
                        label="订单金额/元"
                        :width="payStatus == 23 ? 110 : 90"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="date"
                        label="操作"
                        :width="payStatus == 23 ? 130 : 60"
                      >
                        <template slot-scope="scope">
                          <span
                            style="color: red; cursor: pointer"
                            v-if="payStatus == 1"
                            @click="vieworder(scope.row)"
                            >查看</span
                          >
                          <span
                            v-if="payStatus == 23"
                            style="color: #409eff; cursor: pointer"
                            @click="placeorder(scope.row)"
                            >去支付</span
                          >
                          <el-divider v-if="payStatus == 23" direction="vertical"></el-divider>
                          <span
                            v-if="payStatus == 23"
                            style="color: red; cursor: pointer"
                            @click="deletorder(scope.row)"
                            >删除</span
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      v-if="tableData.length > 0"
                      style="text-align: center; margin-top: 10px"
                      background
                      layout="total,prev, pager, next"
                      :page-size="10"
                      :total="ordertotal"
                      @current-change="currentchangge"
                    ></el-pagination>
                  </el-col>
                </el-row>
              </div>
              <div
                style="text-align: center; margin-top: 20px"
                v-if="officeTab"
              >
                <el-pagination
                  background
                  hide-on-single-page
                  :page-size.sync="officeQueryParams.pageSize"
                  :current-page.sync="officeQueryParams.pageNum"
                  layout="prev, pager, next"
                  :total="officeTotal"
                  @current-change="handleOfficeChange"
                >
                </el-pagination>
              </div>
            </el-card>
            <el-card shadow="never" class="box-card">
              <div>
                <el-row :gutter="15">
                  <el-col class="comtab" :span="24">
                    <div class="left">最近使用产品</div>
                  </el-col>
                  <el-col :span="24">
                    <el-empty
                      v-if="!resentProductList.length"
                      :image="
                        require('../../static/img/display-img/noData.png')
                      "
                      description="暂无产品"
                    ></el-empty>
                  </el-col>
                  <el-col
                    class="comcol"
                    :span="6"
                    v-for="(item, index) in resentProductList"
                    :key="index"
                  >
                    <el-button
                      class="combutton"
                      plain
                      @click="handleItemClick(item)"
                    >
                      <div>
                        <span>
                          {{ item.sysName }}
                        </span>
                      </div>
                      <div class="lastuse">
                        <span>上次打开{{ item.createTime }}</span>
                      </div>
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card shadow="never" class="box-card">
              <div>
                <el-row :gutter="15">
                  <el-col class="comtab" :span="24">
                    <div class="left">平台资讯</div>
                  </el-col>
                  <el-col class="comcol" :span="24">
                    <ul>
                      <li v-for="(item, index) in rows" :key="index">
                        <div class="date">
                          <div class="number">
                            <p class="day">
                              {{ item.day }}
                            </p>
                            <p class="mon">{{ item.month }}月</p>
                          </div>
                        </div>
                        <p class="content" @click="openArticle(item)">
                          {{ item.title }}
                        </p>
                      </li>
                    </ul>
                  </el-col>
                </el-row>
              </div>
              <div style="text-align: center">
                <el-pagination
                  background
                  hide-on-single-page
                  :page-size.sync="queryParams.pageSize"
                  :current-page.sync="queryParams.pageNum"
                  layout="prev, pager, next"
                  :total="total"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="never" class="box-card header-card">
              <div class="header">
                <div class="icon">
                  <img
                    style="width: 58px; height: 58px"
                    src="../assets/images/console/userimg.png"
                    alt=""
                  />
                </div>
                <div class="info">
                  <p class="name">{{ $store.state.user.userName }}</p>
                  <!-- <p class="company"> {{ userName }} </p> -->
                  <div class="addCompany" v-if="companyType == 3">
                    <p>未加入企业</p>
                    <div @click="openComClick">点击申请</div>
                  </div>
                  <div class="addCompany" v-if="companyType == 2">
                    <p>加入企业申请审核中</p>
                  </div>
                  <div class="addCompany" v-if="companyType == 1">
                    <p>{{ companyUserName }}</p>
                  </div>
                  <div class="addCompany" v-if="companyType == 0">
                    <p>加入企业申请未通过</p>
                    <div @click="openReason = true">查看未通过原因</div>
                  </div>
                </div>
              </div>
              <el-row :gutter="15">
                <el-col :span="22" :offset="1">
                  <div class="team">
                    <div class="teambox">
                      <div class="yingyong">
                        <img
                          src="../assets/images/console/yingyong.png"
                          alt=""
                        />
                        <p class="team-title">我的产品</p>
                        <p class="number">
                          <span style="font-size: 18px; font-weight: bold">
                            {{ myproductnum || 0 }}
                          </span>
                          款
                        </p>
                      </div>
                      <div class="tuandui">
                        <img
                          src="../assets/images/console/tuandui.png"
                          alt=""
                        />
                        <p class="team-title">团队人数</p>
                        <p class="number">
                          <span style="font-size: 18px; font-weight: bold">
                            {{ myteammenbernum || 1 }}
                          </span>
                          人
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <el-card shadow="never" class="box-card">
              <a-calendar
                :fullscreen="false"
                @panelChange="onPanelChange"
                @select="selectData"
              >
                <template
                  #headerRender="{ value, type, onChange, onTypeChange }"
                >
                  <div style="padding: 10px">
                    <a-row type="flex" justify="center">
                      <a-col>
                        <a-select
                          size="small"
                          :dropdown-match-select-width="false"
                          class="my-year-select"
                          :value="String(value.year())"
                          @change="
                            (newYear) => {
                              onChange(value.clone().year(newYear));
                            }
                          "
                        >
                          <a-select-option
                            v-for="val in getYears(value)"
                            :key="String(val)"
                            class="year-item"
                          >
                            {{ val }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                      <a-col>
                        <a-select
                          size="small"
                          :dropdown-match-select-width="false"
                          :value="String(value.month())"
                          @change="
                            (selectedMonth) => {
                              onChange(
                                value.clone().month(parseInt(selectedMonth, 10))
                              );
                            }
                          "
                        >
                          <a-select-option
                            v-for="(val, index) in getMonths(value)"
                            :key="String(index)"
                            class="month-item"
                          >
                            {{ val }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                  </div>
                </template>
              </a-calendar>
              <a-divider />
              <div style="min-height: 140px">
                <el-empty
                  v-if="scheduleRows === null || scheduleRows.length === 0"
                  :image="require('../../static/img/display-img/noData.png')"
                  :image-size="80"
                  description="暂无日程"
                ></el-empty>
                <ul class="richeng">
                  <li v-for="(item, index) in scheduleRows" :key="index">
                    <el-row :gutter="1">
                      <el-col :span="6">
                        <span
                          style="
                            color: #999;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: normal;
                          "
                          >{{ item.intervalTime }}</span
                        >
                      </el-col>
                      <el-col :span="14">
                        <span
                          style="
                            display: inline-block;
                            width: 150px;
                            height: 27px;
                            line-height: 27px;
                            overflow: hidden;
                            color: var(--666, #666);
                            text-overflow: ellipsis;
                            whitespace: nowrap;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            cursor: pointer;
                          "
                          @click="scheduleDetail(item.id)"
                        >
                          {{ item.title }}
                        </span>
                      </el-col>
                      <el-col :span="4">
                        <span class="right" @click="cancelSchedule(item)">
                          取消日程
                        </span>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
                <div>
                  <el-row type="flex" :gutter="15" justify="end">
                    <el-col :span="5" style="text-align: right">
                      <img
                        style="width: 42px; height: 42px; cursor: pointer"
                        src="../assets/images/console/add.png"
                        alt=""
                        @click="openScheduleFrom('ruleForm')"
                    /></el-col>
                  </el-row>
                </div>
                <div>
                  <el-pagination
                    background
                    hide-on-single-page
                    :page-size.sync="scheduleParams.pageSize"
                    :current-page.sync="scheduleParams.pageNum"
                    layout="prev, pager, next"
                    :total="scheduleTotal"
                    @current-change="getScheduleData"
                  >
                  </el-pagination>
                </div>
              </div>
            </el-card>
            <el-card style="min-height: 200px" shadow="never" class="box-card">
              <el-col class="newstab" :span="24">
                <div class="left tab">
                  <div
                    :class="isactive == 1 ? 'active' : ''"
                    @click="changeNtab(1)"
                  >
                    通知公告
                  </div>
                  <div
                    :class="isactive == 2 ? 'active' : ''"
                    @click="changeNtab(2)"
                  >
                    制度规范
                  </div>
                  <div
                    :class="isactive == 3 ? 'active' : ''"
                    @click="changeNtab(3)"
                  >
                    行业政策
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <el-empty
                  v-if="articleRows === null || articleRows.length === 0"
                  :image="require('../../static/img/display-img/noData.png')"
                  :image-size="80"
                  description="暂无数据"
                ></el-empty>
              </el-col>
              <ul style="margin-top: 50px">
                <li
                  v-for="(item, index) in articleRows"
                  :key="index"
                  style="margin-top: 20px; vertical-align: middle"
                  @click="openArticle(item)"
                >
                  <el-row :gutter="15">
                    <el-col :span="16">
                      <p
                        style="
                          margin: 0;
                          line-height: 18px;
                          padding: 0;
                          line-height: 27px;
                          font-size: 14px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          cursor: pointer;
                        "
                      >
                        {{ item.title }}
                      </p>
                    </el-col>
                    <el-col :span="8">
                      <span
                        style="
                          display: inline-block;
                          font-size: 12px;
                          line-height: 27px;
                          color: #999;
                          width: 115px;
                        "
                        >{{ item.createTime }}</span
                      >
                    </el-col>
                  </el-row>
                </li>
              </ul>
              <div>
                <el-pagination
                  background
                  hide-on-single-page
                  :page-size.sync="coArticleParams.pageSize"
                  :current-page.sync="coArticleParams.pageNum"
                  layout="prev, pager, next"
                  :total="coArticleTotal"
                  @current-change="currentArticleChange"
                >
                </el-pagination>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-row>
      <div class="cloud">
        <img src="@/assets/images/cloud.png" alt="" />
      </div>
    </div>
    <el-dialog title="加入企业申请" width="30%" :visible.sync="openCompany">
      <el-form :model="companyForm" :rules="companyRules" ref="ruleCompanyForm">
        <el-form-item label="姓名：" prop="userName" label-width="180px">
          <el-input
            style="width: 80%"
            v-model="companyForm.userName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="企业统一社会信用代码："
          prop="companyCode"
          label-width="180px"
        >
          <el-input
            style="width: 80%"
            placeholder="请输入申请加入的企业统一社会信用代码"
            v-model="companyForm.companyCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName" label-width="180px">
          <el-input
            style="width: 80%"
            placeholder="请输入申请加入的企业名称"
            v-model="companyForm.companyName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请理由：" label-width="180px" prop="applyReason">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入"
            style="width: 80%"
            v-model="companyForm.applyReason"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openCompany = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitCompanyInfo('ruleCompanyForm')"
          size="small"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="查看未通过原因" width="30%" :visible.sync="openReason">
      <el-form :model="rejectForm" ref="ruleCompanyForm">
        <el-form-item label="姓名：" prop="userName" label-width="180px">
          <p class="ctbox">{{ rejectForm.userName }}</p>
          <!-- <el-input style="width: 80%" v-model="rejectForm.userName"  disabled></el-input> -->
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName" label-width="180px">
          <p class="ctbox">{{ rejectForm.companyName }}</p>
          <!-- <el-input style="width: 80%" v-model="rejectForm.companyName" autocomplete="off" disabled></el-input> -->
        </el-form-item>
        <el-form-item
          label="未通过理由："
          label-width="180px"
          prop="applyReason"
        >
          <p class="ctbox">{{ rejectForm.rejectReason }}</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openReason = false" class="footerbt" size="small"
          >确认</el-button
        >
        <el-button type="primary" @click="complyAgain" size="small"
          >重新申请</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="新增日程"
      width="30%"
      :visible.sync="dialogFormVisible"
      top="10vh"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <el-input
            style="width: 80%"
            placeholder="请输入标题"
            v-model="form.title"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="开始时间"
          prop="startTime"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            style="width: 80%"
            v-model="form.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="结束时间"
          prop="endTime"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            style="width: 80%"
            v-model="form.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地点" prop="region" :label-width="formLabelWidth">
          <el-input
            style="width: 80%"
            placeholder="请输入地点"
            v-model="form.region"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容" :label-width="formLabelWidth" prop="content">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            style="width: 80%"
            v-model="form.content"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div style="width: 100%; height: 1px; background: #ccc"></div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding-top: 10px;
          "
        >
          <el-form-item prop="remindV" label=" " label-width="20px">
            <el-select
              v-model="form.remindV"
              placeholder="选择提醒时间"
              style="width: 160px"
            >
              <el-option
                v-for="item in startTimeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="repeats" label=" " label-width="20px">
            <el-select
              v-model="form.repeats"
              placeholder="选择开始中提醒"
              style="width: 160px"
            >
              <el-option
                v-for="item in endTimeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSchedule('ruleForm')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="rixingyishan" width="13%">
      <div class="erweima">
        <img src="@/assets/images/erweima.jpg" alt="" />
      </div>
    </el-dialog>
    <el-dialog
      title="日程详情"
      width="30%"
      :visible.sync="detailShow"
      top="10vh"
    >
      <div style="display: flex">
        <div>
          <h3>{{ dataDetail.title }}</h3>
          <p>时间：{{ dataDetail.startTime + "-" + dataDetail.endTime }}</p>
          <p>
            提醒：{{
              dataDetail.remindV == "-1"
                ? "不提醒"
                : `提前${dataDetail.remindV}分钟提醒`
            }}
          </p>
          <p>
            重复：{{
              dataDetail.repeats == "-1"
                ? "不提醒"
                : `${dataDetail.repeats}分钟后提醒`
            }}
          </p>
        </div>
        <div>
          <img
            style="width: 30px; height: 30px; margin-left: 20px"
            v-if="dataDetail.scheduleStatus == '1'"
            src="../assets/images/completed.png"
            alt=""
            srcset=""
          />
          <img
            style="width: 30px; height: 30px; margin-left: 20px"
            v-else
            src="../assets/images/completing.png"
            alt=""
            srcset=""
          />
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
        v-if="dataDetail.scheduleStatus != '1'"
      >
        <el-button @click="complete">完 成</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看订单"
      width="30%"
      :visible.sync="viewordersdialog"
      top="10vh"
    >
      <el-descriptions :column="1">
        <el-descriptions-item label="订单日期">{{
          orderinfodata.create_time
        }}</el-descriptions-item>
        <el-descriptions-item label="订单编号">{{
          orderinfodata.order_code
        }}</el-descriptions-item>
        <el-descriptions-item label="产品服务">{{
          orderinfodata.product_name
        }}</el-descriptions-item>
        <el-descriptions-item label="版本号"
          >{{ orderinfodata.app_version }}
        </el-descriptions-item>
        <el-descriptions-item label="支付方式"
          >企业网银支付（中国工商银行）</el-descriptions-item
        >
        <el-descriptions-item label="订单金额">{{
          orderinfodata.order_amount
        }}</el-descriptions-item>
        <el-descriptions-item label="试用年限（年）">
          {{
            orderinfodata.available_duration == 0
              ? "永久有效"
              : orderinfodata.available_duration == 1
              ? "一年"
              : orderinfodata.available_duration == 2
              ? "两年"
              : orderinfodata.available_duration == 3
              ? "三年"
              : orderinfodata.available_duration
          }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">{{
          orderinfodata.is_available == 0 ? "过期" : "正常"
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserInfo,
  getRecord,
  addRecord,
  listProduct,
  articleList,
  getOfficeList,
  saveOrUpdate,
  getApprovalMess,
  consultlist,
  getDemandTrialList,
  getDemandOrderList,
  demandOrderremove,
} from "@/api/console";
import {
  getConsultList,
  listSchedule,
  addSchedule,
  contentDetail,
  completeDetail,
} from "@/api/consult";
import moment from "moment";
import "moment/dist/locale/zh-cn";
import { delScheduleById } from "../api/consult";
import { getDemandOrderById } from "@/api/application.js";
var dayjs = require("dayjs");
var isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
dayjs.extend(isSameOrBefore);

export default {
  name: "Console",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value == "") {
        callback("请选择开始时间");
      } else if (dayjs(value).isAfter(dayjs(this.form.endTime))) {
        callback("开始时间必须早于结束时间");
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value == "") {
        callback("请选择结束时间");
      } else if (dayjs(value).isBefore(dayjs(this.form.startTime))) {
        callback("开始时间必须早于结束时间");
      } else {
        callback();
      }
    };
    return {
      userId: "",
      userName: "",
      formLabelWidth: "120px",
      form: {
        title: "",
        content: "",
        region: "",
        startTime: "",
        endTime: "",
        location: "",
        remind: "NO_REMIND",
        repeats: "",
        remindV: "",
      },
      companyForm: {
        userName: "",
        companyCode: "",
        companyName: "",
        applyReason: "",
      },
      rejectForm: {},
      myproductnum: "",
      myteammenbernum: "",
      dialogFormVisible: false,
      locale: moment.locale("zh-cn"),
      type: false,
      productList: {},
      list: [],
      rows: [],
      articleRows: [],
      records: [],
      activeName: "first",
      isactive: 1,
      isall: false,
      resentProductList: [],
      scheduleRows: [],
      queryParams: {
        articleType: "PT_CONSULT",
        pageNum: 1,
        pageSize: 5,
        showStatus: "1"
      },
      officeQueryParams: {
        pageNum: 1,
        pageSize: 12,
        officeName: "",
      },
      coArticleTotal: undefined,
      coArticleParams: {
        articleType: "CO_NOTICE",
        pageNum: 1,
        pageSize: 5,
        useFlag: 1,
        showStatus: "1",
      },
      scheduleTotal: undefined,
      scheduleParams: {
        pageNum: 1,
        pageSize: 5,
        localDate: undefined,
        scheduleStatus: "a",
      },
      rules: {
        title: [{ required: true, message: "请输入日程标题", trigger: "blur" }],
        startTime: [
          // { required: true, message: '请选择开始时间', trigger: 'blur' },
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        endTime: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        region: [
          { required: true, message: "请输入日程地点", trigger: "blur" },
        ],
        remindV: [
          { required: true, message: "请选择提醒时间", trigger: "change" },
        ],
        repeats: [
          {
            required: true,
            message: "请选择开始后提醒时间",
            trigger: "change",
          },
        ],
      },
      companyRules: {
        companyCode: [
          {
            required: true,
            pattern:
              /^([0-9A-HJ-NP-RT-UW-Y]){2}([0-9]){6}([0-9A-HJ-NP-RT-UW-Y]{10})$/,
            message: "请输入正确的社会信用代码",
            trigger: "blur",
          },
        ],
        applyReason: [
          { required: true, message: "请输入申请理由", trigger: "blur" },
        ],
      },
      total: undefined,
      productTab: false,
      officeTab: true,
      officetList: [],
      officeTotal: undefined,
      officeName: "",
      openCompany: false,
      openReason: false,
      rixingyishan: false,
      companyType: 4,
      companyUserName: "青岛国真智慧科技有限公司",
      comUserName: "",
      startTimeList: [
        {
          label: "开始时提醒",
          value: "0",
        },
        {
          label: "提前5分钟",
          value: "5",
        },
        {
          label: "提前10分钟",
          value: "10",
        },
        {
          label: "提前15分钟",
          value: "15",
        },
        {
          label: "提前30分钟",
          value: "30",
        },

        {
          label: "不提醒",
          value: "-1",
        },
      ],
      endTimeList: [
        {
          label: "不重复",
          value: "-1",
        },
        {
          label: "15分钟后提醒",
          value: "15",
        },
        {
          label: "30分钟后提醒",
          value: "30",
        },
        {
          label: "1小时后提醒",
          value: "60",
        },
      ],
      dataDetail: {
        title: "日程日程日程如此鞥和",
        time: "2020年12月12日 - 2020年12月13日",
        tixing: "开始时提醒",
        chongfu: "15分钟后提醒",
      },
      detailShow: false, // 日程详情弹框
      application: false, //应用市场
      productarr: {}, //咨询和询价
      trialobjList: {}, //试用产品
      loading: false,
      isEmpty: false, //暂无产品占位显示
      payStatus: "1",
      orderTime: "", //订单时间
      tableData: [],
      orderStatus: "",
      ordertotal: 0,
      orderparams: {
        pageNum: 1,
        pageSize: 10,
        productName: "", //应用名称
        s_time: "",
        e_time: "",
      },
      viewordersdialog: false, //查看订单弹窗
      orderinfodata: {}, //订单详情
      productName: "",
    };
  },
  mounted() {
    this.getList();
    this.getOfficeList();
    this.getApprovalMess();
  },
  methods: {
    keywordChange(keywords) {
      this.officeQueryParams.officeName = keywords;
      this.getOfficeList();
    },
    // tab
    allProduct() {
      this.getList();
      this.officeTab = false;
      // this.changeProductType();
      this.productTab = true;
      this.application = false;
    },
    officeProduct() {
      this.officeTab = true;
      this.productTab = false;
      this.application = false;
    },
    openComClick() {
      this.companyForm = {};
      this.companyForm.userName = this.userName;
      console.log(this, "this");

      this.openCompany = true;
    },
    submitSchedule(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addSchedule(this.form).then((res) => {
            if (res.code === 0) {
              this.$message.success("提交成功");
              this.dialogFormVisible = false;
              this.getScheduleData();
            } else {
              this.$message.error("提交失败");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    complyAgain() {
      this.openReason = false;
      this.openCompany = true;
    },
    // 提交企业申请
    submitCompanyInfo(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          saveOrUpdate(this.companyForm).then((res) => {
            if (res.code === 0) {
              this.$message.success("提交成功");
              this.companyType = 2;
              this.openCompany = false;
              // this.getScheduleData();
            } else {
              this.$message.error("提交失败");
              this.openCompany = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 查看企业申请状态

    getApprovalMess() {
      getApprovalMess().then((res) => {
        if (res.data) {
          const { userName, companyCode, companyName, applyReason } = res.data;
          console.log(res.data);
          this.companyForm = {
            userName,
            companyCode,
            companyName,
            applyReason,
          };
          let arr = Object.keys(res.data);
          if (arr.length == 0) {
            this.companyType = 3;
          } else {
            this.companyType = res.data.approvalState;
          }
          this.rejectForm = res.data;
          this.companyUserName = res.data.companyName;
        } else {
          this.userName = localStorage.getItem("userName");
          this.companyType = 3;
        }
        // if (arr == null) {
        //   this.companyType = 3
        // }

        // if (res.data == null) {
        //   this.companyType = 3
        // }

        // 未申请
      });
    },
    openScheduleFrom(formName) {
      this.dialogFormVisible = true;
      this.$refs[formName].resetFields();
    },
    onPanelChange(value, mode) {
      console.log(value, mode);
    },
    selectData(date) {
      this.scheduleParams.localDate = new Date(date).toLocaleString();
      this.getScheduleData();
    },
    cancelSchedule(item) {
      delScheduleById(item.id).then((res) => {
        if (res.code === 0) {
          this.$message.success("取消日程成功");
          this.getScheduleData();
        } else {
          this.$message.error("取消日程失败");
        }
      });
    },
    getMonths(value) {
      const current = value.clone();
      const localeData = value.localeData();
      const months = [];
      for (let i = 0; i < 12; i++) {
        current.month(i);
        months.push(localeData.monthsShort(current));
      }
      return months;
    },
    getYears(value) {
      const year = value.year();
      const years = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        years.push(i);
      }
      return years;
    },
    currentArticleChange(val) {
      this.coArticleParams.pageNum = val;
      if (this.coArticleParams.articleType !== "PT_POLICY") {
        articleList(this.coArticleParams).then((res) => {
          this.articleRows = res.rows;
          this.coArticleTotal = Number(res.total);
        });
      } else {
        getConsultList(this.coArticleParams).then((res) => {
          this.articleRows = res.rows;
          this.coArticleTotal = Number(res.total);
        });
      }
    },
    /**
     * 分页触发逻辑
     * @param val
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      // getConsultList(this.queryParams).then(res => {
      //   this.rows = res.rows;
      //   this.total = Number(res.total);
      // })
      getConsultList(this.queryParams).then((res) => {
        this.rows = res.rows.map((item) => {
          // var publishTime = new Date(item.createTime);
          // item.day = publishTime.getDay();
          // item.month = publishTime.getMonth();
          item.day = dayjs(item.createTime).format("DD");
          item.month = dayjs(item.createTime).format("M");
          return item;
        });
        this.total = Number(res.total);
      });
    },
    handleOfficeChange(val) {
      this.officeQueryParams.pageNum = val;
      this.getOfficeList();
    },
    getScheduleData() {
      listSchedule(this.scheduleParams).then((res) => {
        this.scheduleTotal = res.data.total;
        this.scheduleRows = res.data.rows.map((item) => {
          var startTime = new Date(item.startTime).toLocaleTimeString();
          var endTime = new Date(item.endTime).toLocaleTimeString();
          item.intervalTime =
            startTime.substring(0, startTime.lastIndexOf(":")) +
            "-" +
            endTime.substring(0, endTime.lastIndexOf(":"));
          return item;
        });
      });
    },
    /**
     * 页面加载时数据初始化
     */
    getList() {
      //我的产品初始化
      getUserInfo().then((res) => {
        console.log(res, "ressss");
        this.myproductnum = res.data.pList.length;
        this.myteammenbernum = res.data.teamPersonNum;
        if (res.data.list) {
          this.userId = res.data.list.username || "";
          // this.userName = lres.data.list. ;
          this.comUserName = res.data.list.username || "";
          this.companyForm.userName = this.userName || "";
        }
        let productobj = {};
        res.data.pList.forEach((ele) => {
          if (ele) {
            const arr = String(ele.remark).split("@@");
            ele.url = arr[0];
            ele.desc = arr[1];
            ele.sysName = ele.dict_label;
            if (ele.logo_url) {
              if (window.location.href.indexOf("eiiplat.com") != -1) {
                let urlarr = ele.logo_url.split("/");
                if (urlarr && urlarr.length > 0) {
                  ele.logo_url =
                    window.location.origin +
                    "/" +
                    urlarr[urlarr.length - 2] +
                    "/" +
                    urlarr[urlarr.length - 1];
                }
              }
            }
            if (productobj[ele.parent_classify]) {
              productobj[ele.parent_classify].push(ele);
            } else {
              productobj[ele.parent_classify] = [];
              productobj[ele.parent_classify].push(ele);
            }
          }
        });
        // this.productList=productobj
        this.productList = res.data.pList.map((item) => {
          const arr = String(item.remark).split("@@");
          item.url = arr[0];
          item.desc = arr[1];
          item.sysName = item.dict_label;
          return item;
        });
        this.setisEmpty();
      });

      this.scheduleParams.localDate = new Date().toLocaleString();
      this.getScheduleData();

      //最近产品初始化
      getRecord().then((res) => {
        this.resentProductList = res.rows.map((item) => {
          const arr = item.sysRemark.split("@@");
          item.url = arr[0];
          item.desc = arr[1];
          return item;
        });
      });

      //通知公告,制度规范类数据初始化
      articleList(this.coArticleParams).then((res) => {
        this.articleRows = res.rows;
        this.coArticleTotal = Number(res.total);
      });

      //平台资讯类数据初始化
      getConsultList(this.queryParams).then((res) => {
        this.rows = res.rows.map((item) => {
          // var publishTime = new Date(item.createTime);
          // item.day = publishTime.getDay();
          // item.month = publishTime.getMonth();
          item.day = dayjs(item.createTime).format("DD");
          item.month = dayjs(item.createTime).format("M");
          return item;
        });
        this.total = Number(res.total);
      });
    },
    // 办公用品
    getOfficeList() {
      let params = {
        pageNum: this.officeQueryParams.pageNum,
        pageSize: this.officeQueryParams.pageSize,
        name: this.officeQueryParams.officeName,
      };
      getOfficeList(params).then((res) => {
        this.officetList = res.rows;
        this.officeTotal = res.total;
      });
    },
    changeProductType() {
      this.isall = !this.isall;
      if (this.isall) {
        listProduct({ type: "A" }).then((res) => {
          this.productList = res.data.map((item) => {
            const arr = item.sysRemark.split("@@");
            item.url = arr[0];
            item.desc = arr[1];
            item.sysName = item.systemName;
            return item;
          });
        });
      } else {
        getUserInfo().then((res) => {
          this.productList = res.data.pList.map((item) => {
            const arr = String(item.remark).split("@@");
            item.url = arr[0];
            item.desc = arr[1];
            item.sysName = item.dict_label;
            return item;
          });
          console.log(this.productList, "prlist");
        });
      }
    },
    openArticle(item) {
      if (item.articleType === "CO_RULES" || item.articleType === "CO_NOTICE") {
        this.type = true;
      }
      this.$router.push({
        path: "/ConsultDetails",
        query: {
          id: item.id,
          name: item.articleType,
          type: this.type,
          title: item.articleType,
        },
      });
    },
    handleItemClick(item) {
      addRecord(item).then(() => {
        let windowObj;
        if (
          item.url.indexOf("cwzx") != -1 ||
          item.url.indexOf("scmfin") != -1 ||
          item.url.indexOf("okr") != -1
        ) {
          windowObj = window.open(
            `${item.url}?userId=${localStorage.userId}&token=${localStorage.usertoken}`
          );
        } else if (item.url.indexOf("app") != -1) {
          windowObj = window.open(
            `${item.url}?userName=${localStorage.userName}&token=${localStorage.usertoken}`
          );
        } else if (item.url.indexOf("ProductConsoleRJ") != -1) {
          // const url = item.url.split('//');
          // url[0] = window.location.protocol;
          windowObj = window.open(`${window.location.origin}/ProductConsoleRJ`);
        } else {
          windowObj = window.open(
            `${item.url}?token=${localStorage.usertoken}`
          );
        }
        setTimeout(() => {
          if (windowObj) {
            const username = localStorage.userName;
            if (username.length !== 11) return;
            windowObj.postMessage({ username, type: "username" }, "*");
          }
        }, 3000);

        // this.getList()
      });
    },
    officeItemClick(item) {
      if (item.name === "日行一善") {
        this.$router.push("/DoOneGood/index");
      } else if (item.name === "晨会") {
        this.$router.push("/morningMeet/index");
      } else if (item.name === "会议纪要") {
        this.$router.push("/meetingMinuter/index");
      } else if (item.name === "出差报告") {
        this.$router.push("/businessReport/index");
      } else if (item.name === "日清") {
        this.$router.push("/DayQing/index");
      } else {
        window.open(item.webAddress);
      }
    },
    /**
     * 通知公告,制度规范,行业政策切换页签时数据的获取
     * @param value
     */
    changeNtab(value) {
      this.isactive = value;
      this.coArticleParams.pageNum = 1;
      switch (value) {
        case 1:
          this.coArticleParams.articleType = "CO_NOTICE";
          articleList(this.coArticleParams).then((res) => {
            this.articleRows = res.rows;
            this.coArticleTotal = Number(res.total);
          });
          break;
        case 2:
          this.coArticleParams.articleType = "CO_RULES";
          articleList(this.coArticleParams).then((res) => {
            this.articleRows = res.rows;
            this.coArticleTotal = Number(res.total);
          });
          break;
        case 3:
          this.coArticleParams.articleType = "PT_POLICY";
          getConsultList(this.coArticleParams).then((res) => {
            this.articleRows = res.rows;
            this.coArticleTotal = Number(res.total);
          });
          break;
        default:
      }
    },
    async getNewslist() {
      await getConsultList(this.coArticleParams).then((res) => {
        this.articleRows = res.rows;
        this.coArticleTotal = Number(res.total);
      });
    },
    async scheduleDetail(id) {
      this.detailShow = true;
      const { code, data } = await contentDetail(id);
      if (code != 0) return;
      this.dataDetail = data;
    },
    async complete() {
      this.dataDetail.scheduleStatus = "1";
      const { code } = await completeDetail(this.dataDetail);
      if (code != 0) return;
      this.detailShow = false;
      this.$message.success("已完成");
      this.getScheduleData();
    },
    setapplication() {
      this.officeTab = false;
      this.productTab = false;
      this.application = true;
      this.orderClick();
    },
    copybutton(text) {
      const clipboard = navigator.clipboard;
      if (clipboard) {
        try {
          clipboard.writeText(text);
          this.$message.success("复制成功");
        } catch (err) {
          this.$message.error("复制失败");
        }
      } else {
        if (document.execCommand) {
          const input = document.createElement("input");
          input.value = text;
          document.body.appendChild(input);
          input.select();
          document.execCommand("Copy");
          document.body.removeChild(input);
          this.$message.success("复制成功");
        } else {
          this.$message.error("当前浏览器不支持剪切板复制");
          return;
        }
      }
    },
    openapplication(appUrl) {
      if (appUrl && appUrl.indexOf("http") != -1) {
        window.open(appUrl);
      } else {
        window.open("//" + appUrl, "_blank");
      }
    },
    setisEmpty() {
      if (this.activeName == "zixun" || this.activeName == "xunjia") {
        this.isEmpty = Object.keys(this.productarr).length === 0;
      } else if (this.activeName == "fourth") {
        this.isEmpty = Object.keys(this.trialobjList).length === 0;
      } else if (this.activeName == "first") {
        this.isEmpty = Object.keys(this.productList).length === 0;
      }
      console.log(this.isEmpty, "isEmpty");
    },
    handleClick() {
      this.loading = true;
      // 咨询和询价
      if (this.activeName == "zixun" || this.activeName == "xunjia") {
        let type =
          this.activeName == "zixun"
            ? "咨询"
            : this.activeName == "xunjia"
            ? "询价"
            : "";
        consultlist({ pageNum: 1, pageSize: 1000, type: type }).then((res) => {
          if (res.code == 0) {
            let productarr = {};
            // {title:'111',arr:[]}
            res.data.rows.forEach((element) => {
              if (element.logoUrl) {
                if (window.location.href.indexOf("eiiplat.com") != -1) {
                  let urlarr = element.logoUrl.split("/");
                  if (urlarr && urlarr.length > 0) {
                    element.logoUrl =
                      window.location.origin +
                      "/" +
                      urlarr[urlarr.length - 2] +
                      "/" +
                      urlarr[urlarr.length - 1];
                  }
                }
              }
              if (productarr[element.productClassify]) {
                productarr[element.productClassify].push(element);
              } else {
                productarr[element.productClassify] = [];
                productarr[element.productClassify].push(element);
              }
            });
            this.loading = false;
            // this.productarr = productarr;
            this.productarr = res.data.rows;
            this.setisEmpty();
          } else {
            this.loading = false;
          }
        });
      } else if (this.activeName == "fourth") {
        // 试用
        getDemandTrialList({ pageNum: 1, pageSize: 1000 }).then((res) => {
          if (res.code == 0) {
            let productarr = {};
            res.rows.forEach((element) => {
              if (element.logo_url) {
                if (window.location.href.indexOf("eiiplat.com") != -1) {
                  let urlarr = element.logo_url.split("/");
                  if (urlarr && urlarr.length > 0) {
                    element.logo_url =
                      window.location.origin +
                      "/" +
                      urlarr[urlarr.length - 2] +
                      "/" +
                      urlarr[urlarr.length - 1];
                  }
                }
              }
              if (productarr[element.product_name]) {
                productarr[element.product_name].push(element);
              } else {
                productarr[element.product_name] = [];
                productarr[element.product_name].push(element);
              }
            });
            this.loading = false;
            console.log("trialobjList", productarr.length);
            // this.trialobjList = productarr;
            this.trialobjList = res.rows
            this.setisEmpty();
          } else {
            this.loading = false;
          }
        });
      } else if (this.activeName == "first") {
        this.getList();
      }
    },
    ordergetList() {
      if (this.payStatus == "23") {
        this.orderparams.s_time = "";
        this.orderparams.e_time = "";
        this.orderTime = "";
      }
      this.orderparams.pageNum = 1;
      this.orderClick();
    },
    orderClick() {
      console.log(this.payStatus, "payStatus");
      let obj = Object.assign(this.orderparams, { payStatus: this.payStatus });

      console.log(obj, "obj---");
      getDemandOrderList(obj).then((res) => {
        if (res.code == 0) {
          this.tableData = res.rows;
          this.ordertotal = res.total;
        }
      });
    },
    currentchangge(val) {
      this.orderparams.pageNum = val;
      this.orderClick();
      console.log(val, "val---");
    },
    ordersearch() {
      this.orderClick();
      this.orderparams.pageNum = 1;
    },
    clearSearch() {
      this.orderparams.s_time = "";
      this.orderparams.e_time = "";
      this.orderparams.productName = "";
      this.orderTime = "";
      this.orderparams.pageNum = 1;
      this.orderClick();
    },
    timeChange(val) {
      console.log(val, "val==");
      if (val) {
        this.orderparams.s_time = val[0];
        this.orderparams.e_time = val[1];
      } else {
        this.orderparams.s_time = "";
        this.orderparams.e_time = "";
      }
    },
    async vieworder(row) {
      this.viewordersdialog = true;
      const { code, data } = await getDemandOrderById({
        orderCode: row.order_code,
      });
      if (code == 0) {
        this.orderinfodata = data;
      }
    },
    placeorder(row) {
      console.log(row, "row");
      this.$router.push({ path: "/order", query: { id: row.order_code } });
    },
    deletorder(row) {
      console.log(row);
      this.$confirm("是否确认删除此笔支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          demandOrderremove({ id: row.id }).then((res) => {
            if (res.code == 0) {
              this.orderClick();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // setproduct(val){
    //   console.log(val,'val---')
    //   this.handleClick();
    // }
    getproductdetail(item) {
      console.log(item, "----");
      if (this.activeName == "zixun") {
        this.$router.push({
          path: "/consulting",
          query: { id: item.id, name: item.productName, status: "view" },
        });
      } else if (this.activeName == "xunjia") {
        this.$router.push({
          path: "/inquiry",
          query: { id: item.id, status: "view" },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.erweima {
  width: 210px;
  height: 210px;

  img {
    width: 100%;
    height: 100%;
  }
}

/deep/ .el-empty {
  padding: 0;
}

p {
  line-height: 1;
}

/deep/ .ant-divider {
  margin: 10px 0;
}

/deep/.el-link--inner {
  font-size: 14px;
}

/deep/.ant-fullcalendar {
  border: none;
}

/deep/.el-row {
  width: 100%;
}

/deep/.el-button {
  &:hover {
    background-color: #ecf5ff;
    border-color: #409eff;
    color: #409eff;
  }
}

// /deep/ .el-dialog--center .el-dialog__body {
//   align-items: center;
// }

.richeng {
  li {
    display: flex;
    height: 44px;
    padding: 8px 0px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
}

.ctbox {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 0 !important;
}

/deep/.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409eff;
  color: #fff !important;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #409eff;
}

/deep/.ant-fullcalendar {
  background-color: red !important;
}

.el-row {
  z-index: 1000;
}

.bg {
  width: 100%;
  height: 100%;
  background: url(../assets/images/console/bg-img.png);
  background-size: 100% 100%;
}

.container {
  width: 1280px;
  margin: 0 auto;
  position: relative;

  .cloud {
    position: absolute;
    z-index: 999;
    right: 100px;
    top: -90px;

    img {
      width: 589px;
      height: 589px;
    }
  }
}

ul {
  list-style: none;
  padding: 0;
}

.product-list {
  width: 100%;
  min-height: 239px;
  background: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #e8ebf3;
}

.recent-list {
  min-height: 182px;
  background: #ffffff;
  border: 1px solid #e8ebf3;
  margin-top: 30px;
  padding: 20px;
  box-sizing: border-box;
}

.document {
  background: #ffffff;
  border: 1px solid #e8ebf3;
  height: 247px;
  margin-top: 30px;
  padding: 20px;

  ul {
    padding: 0;

    li {
      list-style: none;
      line-height: 35px;

      &:hover {
        color: #e50009;
        cursor: pointer;
      }
    }
  }
}

.h1 {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  color: #131415;
}

.box {
  height: 75px;
  background: #ffffff;
  border: 1px solid #e8ebf3;
  margin-top: 20px;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;

  .title {
    font-size: 16px;
    font-weight: 400;
    height: 22px;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .desc {
    font-size: 12px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.7);
    height: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover .title {
    color: #e50009;
  }
}

.combutton {
  width: 100%;
  height: 100px;
  background: url(../assets/images/console/btbg.png) !important;
  background-size: 100% 100% !important;
  text-align: left;

  & > span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  div:first-child {
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;

    span {
      font-size: 0.9rem !important;
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .lastuse {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      font-size: 12px !important;
    }
  }
}

.combutton_office {
  width: 100%;
  height: 100px;
  background: url(../assets/images/console/btbg.png) !important;
  background-size: 100% 100% !important;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;

  .com_office {
    display: flex;
    gap: 8px;
    align-items: center;

    .com_office_img {
      width: 40px;
      height: 40px;

      > img {
        width: 40px;
        height: 40px;
      }
    }

    .com_office_name {
      width: 110px;
      line-height: 20px;

      .text {
        font-size: 14px;
        overflow: hidden;
        white-space: normal;
        line-height: 20px;
        word-wrap: break-word !important;
        margin: 0;
      }
    }
  }
}

.comcol {
  margin-top: 20px;
  /deep/ .el-tabs__item{
    font-weight: bold;
  }
  ul {
    li {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .date {
        width: 45px;
        height: 44px;
        background-color: #e8ebf3;
        padding-top: 6px;
        border-radius: 2px;

        .number {
          width: 43px;
          height: 42px;
          background-color: #f2f3f5;
          margin-left: 1px;
          text-align: center;
          padding-top: 2px;

          p {
            margin: 0;
            padding: 0;
          }

          .day {
            font-size: 16px;
            // margin-top: 6px;
          }

          .mon {
            font-size: 12px;
            margin-top: 2px;
            color: #99a7ba;
          }
        }
      }

      .content {
        margin: 0;
        padding: 0;
        margin-left: 20px;
        cursor: pointer;
        font-size: 14px !important;
        position: relative;

        &:hover {
          &::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            height: 0;
            bottom: -5px;
            border-bottom: 1px solid #409eff;
          }
        }
      }
    }
  }
}

.comtab {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tab {
    font-size: 16px;
    position: relative;
    cursor: pointer;
    font-weight: bold;
    display: flex;

    .left_product {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      display: flex;
      color: #999;
    }

    .left_product_choose {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      display: flex;

      &::after {
        content: "";
        width: 64px;
        height: 3px;
        display: inline-block;
        background-color: #4081ff;
        position: absolute;
        left: 0;
        bottom: -8px;
      }
    }
  }

  .left {
    font-size: 16px;
    position: relative;
    cursor: pointer;
    font-weight: bold;
    display: flex;

    &::after {
      content: "";
      width: 64px;
      height: 3px;
      display: inline-block;
      background-color: #4081ff;
      position: absolute;
      left: 0;
      bottom: -8px;
    }
  }

  .right {
    font-size: 12px;
    color: #4081ff;
    cursor: pointer;
  }
}

.box-card {
  margin-bottom: 20px;
  z-index: 1000;
  background-image: linear-gradient(#F3F5F8, #ffffff);
  border: 2px solid #ffffff;
  box-shadow: 0 12px 12px -12px rgba(0, 0, 0, 0.1);
  &:last-child {
    margin-bottom: 0;
  }

  &.header-card {
    background-color: #f3f6fa;

    .header {
      display: flex;

      .icon {
        margin-left: 4.16667%;
      }

      .info {
        margin-left: 20px;

        .addCompany {
          display: flex;
          align-items: center;
          gap: 10px;

          p {
            font-size: 14px;
          }

          div {
            font-size: 14px;
            // width: 80px;
            padding: 0 5px;
            box-sizing: border-box;
            height: 30px;
            background: #4081ff;
            color: #f2f3f5;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }

        p {
          margin: 0;
          padding: 0;
        }

        .name {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 6px;
        }

        .company {
          font-size: 14px;
          color: #999;
        }
      }
    }

    .team {
      width: 100%;
      height: 138px;
      margin-top: 20px;
      margin: 20px auto 0px;
      background: url(../assets/images/console/teamimg.png);
      background-size: 100% 100%;
      padding-top: 22px;

      .teambox {
        width: 246px;
        height: 116px;
        margin: 0 auto;
        display: flex;

        p {
          margin: 0;
          padding: 0;
          font-size: 14px;
          color: #fff;
        }

        img {
          width: 58px;
          height: 58px;
        }

        .team-title {
          // margin-bottom: 10px;
          margin-top: 12px;
          margin-bottom: 5px;
        }

        .tuandui {
          width: 50%;
          height: 100%;
          text-align: center;
        }

        .yingyong {
          width: 50%;
          height: 100%;
          text-align: center;
        }
      }
    }
  }
}

.right {
  font-size: 12px;
  color: #4081ff;
  cursor: pointer;
  text-align: right;
}

.newstab {
  display: flex;
  justify-content: space-between;
  height: 30px;
  // margin-bottom: 28px;

  .left {
    display: flex;

    > div {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      margin-left: 10px;
    }

    &.tab {
      > div {
        font-weight: normal;
        text-align: center;
        width: 80px;

        &:first-child {
          margin-left: 0;
        }

        &.active {
          font-weight: bold;

          &::after {
            content: "";
            width: 64px;
            height: 3px;
            display: inline-block;
            background-color: #4081ff;
            position: absolute;
            left: 8px;
            bottom: 0px;
          }
        }
      }
    }
  }
}

// ::v-deep(.footerbt span) {

//   font-size: 12px !important;

// }
.dialog-footer {
  display: flex;
  justify-content: center;
}
.product-div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.product-style {
  flex-basis: 50%;
  box-sizing: border-box;
  min-height: 160px;
  padding: 10px;
}
.product-detail {
  cursor: pointer;
  width: 100%;
  height: 100%;
  //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
}
.product-toxiang {
  width: 100px;
  height: 100%;
  padding: 10px 0px 10px 10px;
}
.product_content {
  flex: 1;
  padding: 20px;
   background: #F1F5FB;
  border: 1px solid #ffffff;
  border-radius: 4px;
  & > div:nth-child(1) {
    height: 24px;
    line-height: 24px;
    span:nth-child(1) {
      color: #000;
      font-size: 16px;
      line-height: 24px;
    }
    span:last-child {
      font-size: 10px;
      float: right;
      margin-top: 3px;
      padding: 2px 6px;
      border-radius: 4px;
      font-weight: 400;
      line-height: 14px;
    }
  }
  .demandDesc {
    font-size: 12px;
    font-weight: 400;
    color: #999;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 18px;
    margin-top: 6px;
  }
}
.redspan {
  color: #ffffff;
  background-color: #e50009;
}
.greenspan {
  color: #ffffff;
  background-color: #27d24a;
}
.bluespan{
  color: #ffffff;
  background-color: #4081FF;
}
.productintroduce {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 600;
  font-size: 18px;
  padding: 0px 10px;
  & > span::before {
    content: "";
    display: inline-block;
    height: 20px;
    width: 4px;
    margin-right: 4px;
    vertical-align: middle;
    border: 0;
    background: #1890ff;
  }
}
.trialList {
  font-size: 12px;
  color: #333333;
  margin-top: 6px;
  line-height: 18px;
  & > p {
    margin: 0px;
    margin-top: 5px;
    line-height: 16.8px;
    &.desc{
      color: #999999;
    }
  }
  .a-link:hover {
    color: #1890ff;
  }
  .copytext {
    color: #1890ff;
    margin-left: 10px;
  }
  p:nth-child(1) {
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: inherit;
    margin-top: 0px;
    margin-bottom: 12px;
  }
}

/deep/ .el-descriptions-item__container {
  display: flex;
}
/deep/ .el-descriptions-item__label {
  display: block !important;
  width: 30%;
  text-align: right;
  font-weight: bold;
}
/deep/ .el-descriptions-item__content {
  display: block !important;
  width: 70%;
  text-align: left;
  color: #000;
}
/deep/ .el-table .cell {
  padding-left: 0px !important;
  padding-right: 5px !important;
}
/deep/ .el-empty__image{
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Console.vue